module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0145.jpg?v=5def797d";